// File: noviopus-ats-client/src/features/Job/types.ts

// --- Step 1: Basics ---
export interface JobBasics {
  title: any;
  titleName?: string;
  type: number; 
  numRecruits: number | string; 
  description: string;
  salaryPeriod: string;
  salaryFrom: number | string;
  salaryTo: number | string;
  currency: string;
  useOrganizationDefaults: boolean;
  isWorkFromHome: boolean;
  distance: number;
}

// --- Step 2: Brand (Conditional) ---
export interface JobBrand {
  header?: any; 
  logo?: any;
  albums?: any[]; 
  workingDays?: number[]; 
  workingHoursType?: string;
  startWorkingTime?: string;
  endWorkingTime?: string;
  benefits?: string[]; 
  workplaceTypes?: string[]; 
  remotePolicy?: string; 
  remoteDays?: number;
}

// --- Step 3: Requirements ---
export interface JobRequirementItem {
    id?: string;
    required: boolean;
    level?: number; 
}

export interface JobSkill extends JobRequirementItem {
    skillId?: string; 
    name: string; 
}

export interface JobLanguage extends JobRequirementItem {
    languageId?: string;
    name: string;
}

export interface JobEducation extends JobRequirementItem {
    degreeTypeId?: string;
    fieldOfStudyId?: string;
    name?: string; 
}

export interface JobWorkExperience extends JobRequirementItem {
    jobTitleId?: string;
    name: string;
}

export interface JobRequirements {
  locationId: string; 
  locationAddress?: string; 
  location?: any;
  
  isWorkFromHome: boolean;
  distance: number;

  skills: JobSkill[];
  languages: JobLanguage[];
  educations: JobEducation[];
  workExperience: JobWorkExperience[];
}

// --- Step 4: Workflow ---

export interface HiringMember {
  userId: string;
  role: 'admin' | 'hr' | 'interviewer' | 'participant';
  name?: string;
  avatar?: string;
  email?: string;
  jobTitle?: string;
}

export interface WorkflowStage {
  id?: string;
  name: string;
  type: string;
  teamMembers: HiringMember[];
  isLocked?: boolean;
}

export const DEFAULT_STAGES: WorkflowStage[] = [
  { name: 'Screen', type: 'Screen', teamMembers: [] },
  { name: 'Phone', type: 'Phone', teamMembers: [] },
  { name: 'Interview', type: 'Interview', teamMembers: [] },
  { name: 'Offer', type: 'Offer', teamMembers: [] },
  { name: 'Hire', type: 'Hire', teamMembers: [], isLocked: true }
];

export interface JobWorkflow {
  workflowId?: string;
  workflowName: string;
  hiringManager: HiringMember | null;
  teamMembers: HiringMember[]; 
  stages: WorkflowStage[];
  // UI-Only field for Template Selector
  templateSelector?: string; 
}

// --- The Consolidated Draft Object ---
export interface JobDraft extends JobBasics, JobBrand, JobRequirements, JobWorkflow {
  id?: string;
  _id?: string;
  status?: number; 
  companyId?: string; 
}

export interface JobCreateState {
  draft: JobDraft;
  loading: boolean;
  error: string | null;
  saveStatus: 'idle' | 'saving' | 'success' | 'error';
  // FIX: Match the slice implementation
  parsingStatus: 'idle' | 'loading' | 'success' | 'error';
  parsedData: Partial<JobRequirements> | null;
  showOrgSelector: boolean;
}